export const REMOVE_REGISTRATION_DATA = 'REMOVE_REGISTRATION_DATA';

export const SET_COMPANY_REGISTRATION_DATA = 'SET_COMPANY_REGISTRATION_DATA';
export const SET_REGISTRATION_CURRENT_STEP = 'SET_REGISTRATION_CURRENT_STEP';
export const SET_REGISTRATION_FILLED_STEPS_COUNT = 'SET_REGISTRATION_FILLED_STEPS_COUNT';
export const SET_REGISTRATION_VISITED_STEPS_COUNT = 'SET_REGISTRATION_VISITED_STEPS_COUNT';

export const SET_INDUSTRIES = 'SET_INDUSTRIES';
export const SET_REGULATIONS = 'SET_REGULATIONS';
export const SET_OFFICE_LOCATIONS = 'SET_OFFICE_LOCATIONS';
export const SET_AMOUNT_OF_EMPLOYEES = 'SET_AMOUNT_OF_EMPLOYEES';
export const SET_CYBERSECURITY_KNOWHOW_OPTIONS = 'SET_CYBERSECURITY_KNOWHOW_OPTIONS';

export const SET_CLIENT_REGISTRATION_DATA = 'SET_CLIENT_REGISTRATION_DATA';

export const SET_REGISTRATION_RECAPTCHA_TOKEN = 'SET_REGISTRATION_RECAPTCHA_TOKEN';
export const SET_EMAIL_VERIFICATION_REQUESTED = 'SET_EMAIL_VERIFICATION_REQUESTED';

export const SET_COMPANY_SUGGESTIONS = 'SET_COMPANY_SUGGESTIONS';
export const SET_COMPANY_REGISTRATION_INFO_LOADING = 'SET_COMPANY_REGISTRATION_INFO_LOADING';
export const SET_COMPANY_REGISTRATION_INFO_LOADING_ERRORS = 'SET_COMPANY_REGISTRATION_INFO_LOADING_ERRORS';
export const CLEAR_COMPANY_REGISTRATION_INFO_LOADING_ERROR = 'CLEAR_COMPANY_REGISTRATION_INFO_LOADING_ERROR';

export const SET_CLIENT_AVATAR = 'SET_CLIENT_AVATAR';
export const SET_IS_USER_POOL_EXISTS = 'SET_IS_USER_POOL_EXISTS';
export const CLEAR_IS_USER_POOL_EXISTS = 'CLEAR_IS_USER_POOL_EXISTS';
export const SET_INVITATION_VALIDATION = 'SET_INVITATION_VALIDATION';
export const SET_INVITATION_VALIDATION_RECAPTCHA_TOKEN = 'SET_INVITATION_VALIDATION_RECAPTCHA_TOKEN';
export const REMOVE_INVITATION_CODE_DATA = 'REMOVE_INVITATION_CODE_DATA';
export const SET_WHITE_LABELING_INFO = 'SET_WHITE_LABELING_INFO';
export const SET_SCAN_ID = 'SET_SCAN_ID';
export const SET_WORKSPACE_ID = 'SET_WORKSPACE_ID';
export const SET_REGISTRATION_USER_EMAIL = 'SET_REGISTRATION_USER_EMAIL';
export const CLEAN_REGISTRATION_USER_EMAIL = 'CLEAN_REGISTRATION_USER_EMAIL';
export const SET_REGISTRATION_IN_PROGRESS = 'SET_REGISTRATION_IN_PROGRESS';
